import React from "react";
import Modal from "react-modal";
import { Button } from "@/components/Button/Button";
import { Lock, AlertTriangle } from "lucide-react";

interface DownloadCLIFileModalProps {
  isModalOpen: boolean;
  onCloseButtonClick: () => void;
  onDownloadAndFinalizeClick: () => void;
  isDownloading: boolean;
  week: number;
  year: number;
}

const DownloadCLIFileModal: React.FC<DownloadCLIFileModalProps> = ({
  isModalOpen,
  onCloseButtonClick,
  onDownloadAndFinalizeClick,
  isDownloading,
  week,
  year,
}) => {
  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={onCloseButtonClick}
      style={{
        content: {
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "8px",
          padding: "24px",
          background: "white",
          boxShadow: "0 10px 25px rgba(0,0,0,.3)",
          width: "calc(100% - 32px)",
          maxWidth: "500px",
          minBlockSize: "fit-content",
          overflowY: "auto",
        },
        overlay: {
          backgroundColor: "rgba(0,0,0,0.3)",
          zIndex: 9999,
        },
      }}
    >
      <h3 className="text-xl font-semibold text-gray-900">
        Download and Lock CLI File for Week {week}
      </h3>

      <div className="py-4">
        <p className="text-gray-600">
          This will lock the mailing list for Week {week}, {year}.
        </p>
        <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <h4 className="text-base font-medium text-blue-900 mb-3">
            What happens when you lock:
          </h4>
          <ul className="space-y-2 text-sm text-blue-800">
            <li>• The week&apos;s campaigns become final</li>
            <li>• The CLI file won&apos;t change</li>
            <li>• You can download the same file multiple times</li>
          </ul>
        </div>

        <div className="mt-4 p-4 bg-yellow-50 border border-yellow-300 rounded-lg">
          <div className="flex items-center">
            <AlertTriangle className="w-5 h-5 text-yellow-600 mr-3" />
            <p className="text-sm text-yellow-800">
              Are you sure you want to download and lock CLI file for Week{" "}
              {week}, {year}?
            </p>
          </div>
        </div>
      </div>

      <div className="mt-6 flex justify-end space-x-3">
        <Button onClick={onCloseButtonClick} size="default" variant="plain">
          Cancel
        </Button>

        <Button
          disabled={isDownloading}
          onClick={onDownloadAndFinalizeClick}
          variant="default"
        >
          <Lock className="w-4 h-4 mr-2" />
          {isDownloading ? "Downloading..." : "Download and Lock"}
        </Button>
      </div>
    </Modal>
  );
};

export default DownloadCLIFileModal;
